import Vue from "vue";

import VueToastr from "vue-toastr";

Vue.use(VueToastr, {
  /* OverWrite Plugin Options if you need */
  defaultTimeout: 3000,
  defaultPosition: "toast-top-right",
  defaultClassNames: ["vueToaster"],
  //defaultClassNames: ["animate__animated", "animate__slideInRight", "vueToaster"]
});

/**
 * Components
 *   1. Component name prefix should "app"-component-name
 * */
Vue.component("app-input", (resolve) => {
  import(/* webpackPreload: true */ "./components/input/Index").then((AsyncComponent) => {
    resolve(AsyncComponent.default);
  });
});
Vue.component("app-pre-loader", require("./components/preloders/Preloader").default);
Vue.component(
  "app-overlay-loader",
  require("./components/preloders/OverlayLoader").default
);
Vue.component("app-modal", require("./components/modal/Modal").default);

Vue.component("app-table", (resolve) => {
  import(/* webpackPreload: true */ "./components/datatable/Index").then(
    (AsyncComponent) => {
      resolve(AsyncComponent.default);
    }
  );
});
Vue.component("app-local-table", (resolve) => {
  import(/* webpackPreload: true */ "./components/datatable/Index").then(
    (AsyncComponent) => {
      resolve(AsyncComponent.default);
    }
  );
});

Vue.component("app-load-more", (resolve) => {
  import(/* webpackPreload: true */ "./components/buttons/LoadMore").then(
    (AsyncComponent) => {
      resolve(AsyncComponent.default);
    }
  );
});
Vue.component("app-pagination", (resolve) => {
  import(/* webpackPreload: true */ "./components/buttons/Pagination").then(
    (AsyncComponent) => {
      resolve(AsyncComponent.default);
    }
  );
});
Vue.component("app-filter", (resolve) => {
  import(/* webpackPreload: true */ "./components/filter/Index").then(
    (AsyncComponent) => {
      resolve(AsyncComponent.default);
    }
  );
});
Vue.component("app-search", (resolve) => {
  import(/* webpackPreload: true */ "./components/datatable/Search").then(
    (AsyncComponent) => {
      resolve(AsyncComponent.default);
    }
  );
});
Vue.component("app-tab-filter", (resolve) => {
  import(/* webpackPreload: true */ "./components/filter/TabFilter").then(
    (AsyncComponent) => {
      resolve(AsyncComponent.default);
    }
  );
});
Vue.component("app-icon", (resolve) => {
  import(/* webpackPreload: true */ "./components/icon/Icon").then((AsyncComponent) => {
    resolve(AsyncComponent.default);
  });
});
Vue.component("app-avatar", (resolve) => {
  import(/* webpackPreload: true */ "./components/avatars/Avatar").then(
    (AsyncComponent) => {
      resolve(AsyncComponent.default);
    }
  );
});
Vue.component("app-avatars-group", (resolve) => {
  import(/* webpackPreload: true */ "./components/avatars-group/AvatarsGroup").then(
    (AsyncComponent) => {
      resolve(AsyncComponent.default);
    }
  );
});
Vue.component("app-tab", (resolve) => {
  import(/* webpackPreload: true */ "./components/tabs/Index").then((AsyncComponent) => {
    resolve(AsyncComponent.default);
  });
});
Vue.component("app-form-wizard", (resolve) => {
  import(/* webpackPreload: true */ "./components/form-wizard/FormWizard").then(
    (AsyncComponent) => {
      resolve(AsyncComponent.default);
    }
  );
});
Vue.component("app-button", (resolve) => {
  import(/* webpackPreload: true */ "./components/buttons/AppButton").then(
    (AsyncComponent) => {
      resolve(AsyncComponent.default);
    }
  );
});
Vue.component("app-breadcrumb", (resolve) => {
  import(/* webpackPreload: true */ "./components/breadcrumb/index").then(
    (AsyncComponent) => {
      resolve(AsyncComponent.default);
    }
  );
});
Vue.component("app-badge", (resolve) => {
  import(/* webpackPreload: true */ "./components/badge/Badge").then((AsyncComponent) => {
    resolve(AsyncComponent.default);
  });
});
Vue.component("app-card-view", (resolve) => {
  import(/* webpackPreload: true */ "./components/card-view/index").then(
    (AsyncComponent) => {
      resolve(AsyncComponent.default);
    }
  );
});
Vue.component("app-template-preview-card", (resolve) => {
  import(
    /* webpackPreload: true */ "./components/template-preview-card/AppTemplatePreviewCard"
  ).then((AsyncComponent) => {
    resolve(AsyncComponent.default);
  });
});
Vue.component("app-note", (resolve) => {
  import(/* webpackPreload: true */ "./components/badge/Note").then((AsyncComponent) => {
    resolve(AsyncComponent.default);
  });
});
Vue.component("app-chart", (resolve) => {
  import(/* webpackPreload: true */ "./components/charts/Index").then(
    (AsyncComponent) => {
      resolve(AsyncComponent.default);
    }
  );
});
Vue.component("app-dropdown-menu", (resolve) => {
  import(/* webpackPreload: true */ "./components/buttons/DropdownMenu").then(
    (AsyncComponent) => {
      resolve(AsyncComponent.default);
    }
  );
});  



 
 


Vue.component("app-navbar", (resolve) => {
  import(/* webpackPreload: true */ "./components/layouts/Navbar").then(
    (AsyncComponent) => {
      resolve(AsyncComponent.default);
    }
  );
});


Vue.component("app-navbar-language-dropdown", (resolve) => {
  import(
    /* webpackPreload: true */ "./components/layouts/navbar-dropdowns/LanguageDropdown"
  ).then((AsyncComponent) => {
    resolve(AsyncComponent.default);
  });
});
Vue.component("app-navbar-notification-dropdown", (resolve) => {
  import(
    /* webpackPreload: true */ "./components/layouts/navbar-dropdowns/NotificationDropdown"
  ).then((AsyncComponent) => {
    resolve(AsyncComponent.default);
  });
});
Vue.component("app-navbar-profile-dropdown", (resolve) => {
  import(
    /* webpackPreload: true */ "./components/layouts/navbar-dropdowns/ProfileDropdown"
  ).then((AsyncComponent) => {
    resolve(AsyncComponent.default);
  });
});
Vue.component("app-widget", (resolve) => {
  import(/* webpackPreload: true */ "./components/dashboard-widget/Index").then(
    (AsyncComponent) => {
      resolve(AsyncComponent.default);
    }
  );
});
Vue.component("app-confirmation-modal", (resolve) => {
  import(/* webpackPreload: true */ "./components/confirmation-modal/Index").then(
    (AsyncComponent) => {
      resolve(AsyncComponent.default);
    }
  );
});
Vue.component("app-empty-data-block", (resolve) => {
  import(/* webpackPreload: true */ "./components/datatable/EmptyData").then(
    (AsyncComponent) => {
      resolve(AsyncComponent.default);
    }
  );
});
Vue.component("app-media-object", (resolve) => {
  import(/* webpackPreload: true */ "./components/media-object/MediaObject").then(
    (AsyncComponent) => {
      resolve(AsyncComponent.default);
    }
  );
});
Vue.component("app-error", (resolve) => {
  import(/* webpackPreload: true */ "./components/error-page/Error").then(
    (AsyncComponent) => {
      resolve(AsyncComponent.default);
    }
  );
});
Vue.component("app-calendar", (resolve) => {
  import(/* webpackPreload: true */ "./components/calendar/Calendar").then(
    (AsyncComponent) => {
      resolve(AsyncComponent.default);
    }
  );
});
Vue.component("app-filter-with-search", (resolve) => {
  import(/* webpackPreload: true */ "./components/filter/FilterWithSearch").then(
    (AsyncComponent) => {
      resolve(AsyncComponent.default);
    }
  );
});
Vue.component("app-submit-button", (resolve) => {
  import(/* webpackPreload: true */ "./components/buttons/SubmitButton").then(
    (AsyncComponent) => {
      resolve(AsyncComponent.default);
    }
  );
});
Vue.component("app-organization-chart", (resolve) => {
  import(
    /* webpackPreload: true */ "./components/organization-chart/OrganizationChart"
  ).then((AsyncComponent) => {
    resolve(AsyncComponent.default);
  });
});
Vue.component("app-tag-manager", (resolve) => {
  import(/* webpackPreload: true */ "./components/tag/TagManager").then(
    (AsyncComponent) => {
      resolve(AsyncComponent.default);
    }
  );
});
Vue.component("markdown-viewer", (resolve) => {
  import(/* webpackPreload: true */ "./components/input/MarkdownViewer").then(
    (AsyncComponent) => {
      resolve(AsyncComponent.default);
    }
  );
});
Vue.component("app-link-dropdown", (resolve) => {
  import(/* webpackPreload: true */ "./components/buttons/AppLinkDropdown").then(
    (AsyncComponent) => {
      resolve(AsyncComponent.default);
    }
  );
});

//Sidebar
//Vue.component('sidebar', (resolve) => {
//   import(/* webpackPreload: true */'./components/layouts/Sidebar').then((AsyncComponent) => {
//   resolve(AsyncComponent.default);
// })});

/**
 * v-calder
 * */
// import Calendar from "v-calendar/lib/components/calendar.umd";
// import DatePicker from "v-calendar/lib/components/date-picker.umd";

// import Calendar from "v-calendar/src/components/Calendar.vue";
// import DatePicker from "v-calendar/src/components/DatePicker.vue";
import { DatePicker } from 'v-calendar';

// Vue.component("v-calendar", Calendar);
Vue.component("v-date-picker", DatePicker);
/**
 * An EventHub to share events between components
 * */
Vue.prototype.$hub = new Vue();

/**
 * test components
 * */
// import './examples/exampleApp';

/**
 * cookies
 */

import AppCookie from "./helpers/cookies/AppCookies";
window.AppCookie = AppCookie;
